/**
 * OrcamentosBlock — orcamentos vinculados ao lead + atalho "Criar orcamento".
 *
 * Lista [numero + situacao Pill] com link pro detalhe do orcamento. O link
 * leva `state.from = /crm/leads/<leadId>` para o Detalhe poder voltar ao
 * cockpit. Botao "Criar orcamento" abre o CriarOrcamentoDialog (pai).
 */
import React from "react";
import { FiExternalLink, FiZap } from "react-icons/fi";
import { Link, useParams } from "react-router-dom";

import Block from "../../../components/Block";
import { SITUACAO_TONE_ORCAMENTO } from "../../Orcamentos/helpers";
import { EmptyMsg, Pill } from "../../Orcamentos/styles";

import { LinhaInfo, LinhaItem, LinhaTitulo } from "./styles";

function OrcamentosBlock({
  orcamentos,
  onCriarOrcamento,
  podeCriar,
  collapsible,
  defaultCollapsed,
}) {
  const { leadId } = useParams();
  const lista = Array.isArray(orcamentos) ? orcamentos : [];

  return (
    <Block
      title={`Orcamentos (${lista.length})`}
      collapsible={collapsible}
      defaultCollapsed={defaultCollapsed}
      actions={
        podeCriar ? (
          <button
            type="button"
            className="btn btn--primary btn--sm"
            onClick={onCriarOrcamento}
          >
            <FiZap size={13} aria-hidden="true" /> Criar orcamento
          </button>
        ) : null
      }
    >
      {lista.length === 0 ? (
        <EmptyMsg style={{ padding: 8 }}>
          Nenhum orcamento vinculado a este lead ainda.
        </EmptyMsg>
      ) : (
        lista.map((o) => (
          <LinhaItem key={o.id}>
            <LinhaInfo>
              <LinhaTitulo style={{ fontFamily: "var(--font-mono)" }}>
                {o.numero}
              </LinhaTitulo>
            </LinhaInfo>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <Pill $tone={SITUACAO_TONE_ORCAMENTO[o.situacao] || "neutral"}>
                {o.situacao}
              </Pill>
              <Link
                to={`/orcamentos/${o.id}`}
                state={{ from: `/crm/leads/${leadId}` }}
                title="Abrir orçamento"
                style={{ color: "var(--ink-3)", display: "inline-flex" }}
              >
                <FiExternalLink size={14} aria-hidden="true" />
              </Link>
            </div>
          </LinhaItem>
        ))
      )}
    </Block>
  );
}

export default OrcamentosBlock;
